
'use strict';
/**
 * @pbdoc disableMenu
 * @name disableMenu
 * @packageName disableMenu
 */
class disableMenu {

    constructor ($rootScope) {
        var service = {};

        service.message = '';

        service.setState = function(state) {
            this.state = state;
            this.sendState();
        };

        service.sendState = function() {
            $rootScope.$broadcast('changeMenuState');
        };

        return service;
    }


}

disableMenu.$inject= ['$rootScope'];

module.exports = disableMenu;